<template>
  <Modal :value="value" v-on="$listeners">
    <p class="pb-2 text-xl font-bold leading-tight">
      {{ $t('popups.removeVoucher.title', { code: voucher.code }) }}
    </p>

    <div
      v-for="(error, index) in errors"
      :key="index"
      class="flex w-full p-4 mt-2 mb-4 bg-white border border-gray-300"
    >
      <div class="flex-shrink-0 w-8">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" v-bind:svg-inline="''" v-bind:class="'w-4.5 h-4.5'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M12.6 0H5.269L0 5.4v7.2L5.4 18h7.2l5.4-5.4V5.4zm1.665 12.189l-2.121 2.121-3.189-3.19-3.189 3.19-2.122-2.121L6.837 9l-3.19-3.189 2.122-2.122 3.189 3.19 3.189-3.19 2.121 2.122L11.08 9z" fill="#c00"/></svg>
      </div>
      <div class="pt-2px xl:pt-0">
        <p class="pb-2 text-sm font-bold leading-none xl:text-lg">
          {{ $t(`errors.type.${error}.title`, brandInfo) }}
        </p>
        <p class="text-xs xl:text-sm" v-html="$t(`errors.type.${error}.description`, brandInfo)" />
      </div>
    </div>

    <div class="flex flex-col-reverse pt-5 xl:flex-row xl:pt-8">
      <div class="mt-4 xl:mt-0 xl:mr-4">
        <Button
          :loading="loading"
          variant="primary-border"
          type="button"
          @click="deleteVoucher"
        >
          {{ $t('popups.removeVoucher.button.submit') }}
        </Button>
      </div>

      <div>
        <Button
          :disabled="loading"
          type="button"
          @click.prevent="$emit('input', false)"
        >
          {{ $t('popups.removeVoucher.button.close') }}
        </Button>
      </div>
    </div>
  </Modal>
</template>

<script lang="ts">
import Modal from '~brand-components/austrian/modal/modal.vue'
import RemoveVoucherPopup from '~app/psp/base/remove-voucher-popup.ts'
import Button from '~brand-components/austrian/button/button.vue'

export default RemoveVoucherPopup.extend({
  components: {
    Modal,
    Button,
  },
})
</script>
